/* eslint-disable max-len */
import { defineMessages } from 'react-intl';

export default defineMessages({

    // title
    TitleHome: {
        id: 'qnb.sph.IpidPage.header.TitleHome',
        defaultMessage: 'Home Insurance'
    },
    TitleTailormade: {
        id: 'qnb.sph.IpidPage.header.TitleTailormade',
        defaultMessage: 'Saga TailorMade Insurance',
    },
    TitleLandlord: {
        id: 'qnb.sph.IpidPage.header.TitleLandlord',
        defaultMessage: 'Saga Landlord Insurance'
    },
    TitleSPHLegalExpenses: {
        id: 'qnb.sph.IpidPage.header.TitleLegalCover',
        defaultMessage: 'Saga Home Legal Expenses Cover'
    },
    TitleSPHSagaHomeEmergency: {
        id: 'qnb.sph.IpidPage.header.TitleSheCover',
        defaultMessage: 'Saga Home Emergency Insurance'
    },
    HomeEmergencyCoverTitle: {
        id: 'qnb.sph.IpidPage.title.HomeEmergencyCoverTitle',
        defaultMessage: 'Home Emergency Cover'
    },
    HomeAndHeatingEmergencyCoverTitle: {
        id: 'qnb.sph.IpidPage.title.HomeAndHeatingEmergencyCoverTitle',
        defaultMessage: 'Home and Heating Emergency Cover'
    },
    AnnualBoilerCoverTitle: {
        id: 'qnb.sph.IpidPage.title.AnnualBoilerCoverTitle',
        defaultMessage: 'Annual Boiler Service'
    },
    CompleteHomeAndHeatingCareTitle: {
        id: 'qnb.sph.IpidPage.title.CompleteHomeAndHeatingCare',
        defaultMessage: 'Complete Home and Heating Care'
    },
    HomeProductTitleBuildingsSPHCover1ContentsSPHCover1: {
        id: 'qnb.sph.IpidPage.title.HomeProductTitleBuildingsSPHCover1ContentsSPHCover1',
        defaultMessage: 'Saga Select Buildings and Contents home insurance'
    },
    HomeProductTitleBuildingsSPHCover1: {
        id: 'qnb.sph.IpidPage.title.HomeProductTitleBuildingsSPHCover1',
        defaultMessage: 'Saga Select Buildings insurance'
    },
    HomeProductTitleContentsSPHCover1: {
        id: 'qnb.sph.IpidPage.title.HomeProductTitleContentsSPHCover1',
        defaultMessage: 'Saga Select Contents insurance'
    },
    HomeProductTitleBuildingsSPHCover6ContentsSPHCover6: {
        id: 'qnb.sph.IpidPage.title.HomeProductTitleBuildingsSPHCover6ContentsSPHCover6',
        defaultMessage: 'Saga Plus Buildings and Contents home insurance'
    },
    HomeProductTitleBuildingsSPHCover6: {
        id: 'qnb.sph.IpidPage.title.HomeProductTitleBuildingsSPHCover6',
        defaultMessage: 'Saga Plus Buildings insurance'
    },
    HomeProductTitleContentsSPHCover6: {
        id: 'qnb.sph.IpidPage.title.HomeProductTitleContentsSPHCover6',
        defaultMessage: 'Saga Plus Contents insurance'
    },
    LandlordProductTitle: {
        id: 'qnb.sph.IpidPage.title.LandlordProductTitle',
        defaultMessage: 'Landlord insurance'
    },
    TailormadeProductTitle: {
        id: 'qnb.sph.IpidPage.title.TailormadeProductTitle',
        defaultMessage: 'Tailormade Home Insurance'
    },
    SPHLegalExpensesProductTitle: {
        id: 'qnb.sph.IpidPage.title.SPHLegalExpensesProductTitle',
        defaultMessage: 'Saga Home Legal Expenses Cover'
    },
    SPHSagaHomeEmergencyProductTitle: {
        id: 'qnb.sph.IpidPage.title.SPHSagaHomeEmergencyProductTitle',
        defaultMessage: 'Home Emergency Cover'
    },
    SPHSagaHomeEmergencyProductTitleHomeAndHeatingEmergency: {
        id: 'qnb.sph.IpidPage.title.SPHSagaHomeEmergencyProductTitleHomeAndHeatingEmergency',
        defaultMessage: 'Home and Heating Emergency Cover'
    },
    InsuranceTypeDesc: {
        id: 'qnb.sph.IpidPage.title.InsuranceTypeDescStart',
        defaultMessage: 'is designed to meet the demands and need of an individual, or group (where applicable), wishing to protect themselves against the financial impact of specified unforeseen circumstances/events relating to'
    },
    InsuranceTypeDescCoverHome: {
        id: 'qnb.sph.IpidPage.title.InsuranceTypeDescCoverSelect',
        defaultMessage: 'Your Saga Select Home Insurance policy'
    },
    InsuranceTypeDescCoverHomePlus: {
        id: 'qnb.sph.IpidPage.title.InsuranceTypeDescCoverPlus',
        defaultMessage: 'Your Saga Plus Home Insurance policy'
    },
    InsuranceTypeDescCoverTailormade: {
        id: 'qnb.sph.IpidPage.title.InsuranceTypeDescCoverTailormade',
        defaultMessage: 'Your Saga Tailormade Home Insurance policy'
    },
    InsuranceTypeDescCoverLandlord: {
        id: 'qnb.sph.IpidPage.title.InsuranceTypeDescCoverLandlord',
        defaultMessage: 'Your Saga Landlord Insurance policy'
    },
    InsuranceTypeDescCoverSPHSagaHomeEmergencyPlus: {
        id: 'qnb.sph.IpidPage.title.InsuranceTypeDescCoverSPHSagaHomeEmergency',
        defaultMessage: 'Your optional Saga Home Emergency cover'
    },
    InsuranceTypeDescCoverSPHLegalExpensesPlus: {
        id: 'qnb.sph.IpidPage.title.InsuranceTypeDescCoverSPHLegalExpenses',
        defaultMessage: 'Your optional Saga Home Legal Expenses cover'
    },
    InsuranceTypeDescCoverSPHSagaHomeEmergency: {
        id: 'qnb.sph.IpidPage.title.InsuranceTypeDescCoverSPHSagaHomeEmergency',
        defaultMessage: 'Your optional Saga Home Emergency cover'
    },
    InsuranceTypeDescCoverSPHLegalExpenses: {
        id: 'qnb.sph.IpidPage.title.InsuranceTypeDescCoverSPHLegalExpenses',
        defaultMessage: 'Your optional Saga Home Legal Expenses cover'
    },
    InsuranceTypeDescCoverableHome: {
        id: 'qnb.sph.IpidPage.title.InsuranceTypeDescCoverableHome',
        defaultMessage: 'your {insuranceType}. We have different levels of cover available with our home insurance, please see your Schedule for your chosen cover level'
    },
    InsuranceTypeDescCoverableTailormade: {
        id: 'qnb.sph.IpidPage.title.InsuranceTypeDescCoverableTailormade',
        defaultMessage: 'your {insuranceType}'
    },
    InsuranceTypeDescCoverableLandlord: {
        id: 'qnb.sph.IpidPage.title.InsuranceTypeDescCoverableLandlord',
        defaultMessage: 'the properties that they let out to tenants'
    },
    InsuranceTypeDescCoverableSPHLegalExpenses: {
        id: 'qnb.sph.IpidPage.title.InsuranceTypeDescCoverableSPHLegalExpenses',
        defaultMessage: 'your legal proceedings'
    },
    InsuranceTypeDescCoverableSPHSagaHomeEmergency: {
        id: 'qnb.sph.IpidPage.title.InsuranceTypeDescCoverableSPHSagaHomeEmergency',
        defaultMessage: 'an emergency in your home'
    },
    InsuranceTypeBuildingsandcontents: {
        id: 'qnb.sph.IpidPage.title.InsuranceTypeBuildingsandcontents',
        defaultMessage: 'Buildings & Contents'
    },
    InsuranceTypeBuildingsonly: {
        id: 'qnb.sph.IpidPage.title.InsuranceTypeBuildings',
        defaultMessage: 'Buildings'
    },
    InsuranceTypeContentsonly: {
        id: 'qnb.sph.IpidPage.title.InsuranceTypeContents',
        defaultMessage: 'Contents'
    },
    HowDoIPay: {
        id: 'qnb.sph.IpidPage.HowDoIPay',
        defaultMessage: 'We offer a choice of monthly or annual payments which can be paid by Direct Debit if eligible. In addition, we offer a choice of annual payments which can be paid by debit or credit card. Payment will be taken when you take out the policy.'
    },
    HowDoIPayRenewalCreditCardOrCheque: {
        id: 'qnb.sph.IpidPage.HowDoIPayRenewalCreditCardOrCheque',
        defaultMessage: 'We offer a choice of monthly or annual payments which can be paid by Direct Debit. In addition, we offer a choice of annual premiums which can be paid by cheque, debit or credit card. Payment will be taken when you renew.'
    },
    HowDoIPayRenewal: {
        id: 'qnb.sph.IpidPage.HowDoIPayRenewal',
        defaultMessage: 'We offer a choice of monthly or annual payments which can be paid by Direct Debit. In addition, we offer a choice of annual premiums which can be paid by cheque, debit or credit card. As you have chosen to pay for your annual policy {singlePayment}by {paymentPlan} {paymentMethod}, your policy will automatically renew for you. Payment will be taken on or around your renewal date.'
    },
    DebitCretidCard: {
        id: 'qnb.sph.IpidPage.DebitCretidCard',
        defaultMessage: 'debit/credit card'
    },
    DirectDebit: {
        id: 'qnb.sph.IpidPage.DirectDebit',
        defaultMessage: 'direct debit'
    },
    Continuous: {
        id: 'qnb.sph.IpidPage.Continuous',
        defaultMessage: 'continuous'
    },
    SinglePayment: {
        id: 'qnb.sph.IpidPage.SinglePayment',
        defaultMessage: 'in one single payment '
    },
    HowDoIPayOther: {
        id: 'qnb.sph.IpidPage.HowDoIPayOther',
        defaultMessage: 'Your optional cover will use the same payment methods that are available under your home insurance policy'
    },
    EndDateMessage: {
        id: 'qnb.sph.IpidPage.EndDateMessage',
        defaultMessage: 'The optional cover starts the same date as your home insurance policy or should you wish to add the optional cover mid way through your policy year then the date will be different, how ever all cover will expire at the same time as your home insurance policy.'
    },

    // Insured All
    AccidentalDamageEndo851: {
        id: 'qnb.sph.IpidPage.insured.AccidentalDamageEndo851',
        defaultMessage: 'Accidental damage to underground pipes and cables, sanitary fittings and fixed glass in doors and windows'
    },
    AccidentalDamageToUnderground: {
        id: 'qnb.sph.IpidPage.insured.AccidentalDamageToUnderground',
        defaultMessage: 'Accidental damage to underground pipes and cables'
    },
    AlternativeAccommodation: {
        id: 'qnb.sph.IpidPage.insured.AlternativeAccommodation',
        defaultMessage: 'Alternative accommodation costs up to £100,000'
    },
    BuildingOrContentAccidentalDamage: {
        id: 'qnb.sph.IpidPage.insured.BuildingOrContentAccidentalDamage',
        defaultMessage: 'Accidental {buildingOrContentAccidentalDamage}'
    },
    BuildingOrContentAccidentalDamageWithAd: {
        id: 'qnb.sph.IpidPage.insured.BuildingOrContentAccidentalDamageWithAd:',
        defaultMessage: 'Accidental {buildingOrContentADAccidentalDamage}'
    },
    AccidentalDamageEndo852: {
        id: 'qnb.sph.IpidPage.insured.AccidentalDamageEndo852:',
        defaultMessage: 'Accidental damage to domestic appliances that are not portable, such as your television, and glass in furniture'
    },
    BuildingsUpTo: {
        id: 'qnb.sph.IpidPage.insured.BuildingsUpTo',
        defaultMessage: 'Buildings up to {rebuildCostBuildings}'
    },
    ContentsUpTo: {
        id: 'qnb.sph.IpidPage.insured.ContentsUpTo',
        defaultMessage: 'Contents up to {contentsTotal}'
    },
    FrozenFood: {
        id: 'qnb.sph.IpidPage.insured.FrozenFood',
        defaultMessage: 'Frozen food cover up to £500'
    },
    FrozenPremier: {
        id: 'qnb.sph.IpidPage.insured.FrozenPremier',
        defaultMessage: 'Frozen food cover up to your contents sum insured'
    },
    ItemsAwayFromHome: {
        id: 'qnb.sph.IpidPage.insured.ItemsAwayFromHome',
        defaultMessage: 'Covered up to £2,500 each (£1,000 for bicycles), up to {personalBelongingsValue} in total'
    },
    ItemsAwayFromHomePlus: {
        id: 'qnb.sph.IpidPage.insured.ItemsAwayFromHomePlus',
        defaultMessage: 'Unspecified personal belongings away from home - covered up to £2,500 each (£1,000 for bicycles), up to {personalBelongingsValue} in total'
    },
    ItemsAwayFromHomeTitle: {
        id: 'qnb.sph.IpidPage.insured.ItemsAwayFromHomeTitle',
        defaultMessage: 'Unspecified personal belongings away from home'
    },
    ValuableContentsInHome: {
        id: 'qnb.sph.IpidPage.insured.ValuableContentsInHome',
        defaultMessage: ' Up to {valuablesLimit} for valuables in your home'
    },
    // Premier insured
    Leaks: {
        id: 'qnb.sph.IpidPage.insured.Leaks',
        defaultMessage: 'Finding, accessing, and repairing a water or oil leak causing damage in your home, up to £5,000'
    },
    PremierLeak: {
        id: 'qnb.sph.IpidPage.insured.PremierLeak',
        defaultMessage: 'Finding, accessing, and repairing a water or oil leak causing damage in your home, up to your buildings sum insured'
    },
    DamageByFire: {
        id: 'qnb.sph.IpidPage.insured.DamageByFire',
        defaultMessage: 'Loss or damage caused by fire, flood, storm, explosion, subsidence, theft, malicious acts or vandalism and escape of water or oil'
    },
    PremierMatchingPairSets: {
        id: 'qnb.sph.IpidPage.insured.PremierMatchingPairSets',
        defaultMessage: 'Matching pairs and sets for {premierMatchingPairSetsValue}'
    },
    PremierMoneyAndCreditcard: {
        id: 'qnb.sph.IpidPage.insured.PremierMoneyAndCreditcard',
        defaultMessage: 'Money and credit card cover up to {premierMoneyAndCreditcardValue} worldwide'
    },
    PersonalLiability: {
        id: 'qnb.sph.IpidPage.insured.PersonalLiability',
        defaultMessage: 'Personal liability cover up to £2 million'
    },
    PremierAlternativeAccommodation: {
        id: 'qnb.sph.IpidPage.insured.PremierAlternativeAccommodation',
        defaultMessage: 'Alternative accommodation costs up to sum insured'
    },
    PropertyOwnersLiability: {
        id: 'qnb.sph.IpidPage.insured.PropertyOwnersLiability',
        defaultMessage: 'Property owners liability up to £2 million'
    },
    // Specified items insured
    SpecifiedItems: {
        id: 'qnb.sph.IpidPage.insured.SpecifiedItems',
        defaultMessage: 'Cover for specified items listed in your Schedule, up to the specified sums insured'
    },
    SpecifiedItemsTitle: {
        id: 'qnb.sph.IpidPage.insured.SpecifiedItemsTitle',
        defaultMessage: 'Specified personal belongings away from home'
    },
    // landlord insured
    LandlordAccidentalDamage: {
        id: 'qnb.sph.IpidPage.insured.LandlordAccidentalDamage',
        defaultMessage: 'Accidental damage included as standard'
    },
    LandlordAlternativeAccommodation: {
        id: 'qnb.sph.IpidPage.insured.LandlordAlternativeAccommodation',
        defaultMessage: 'Alternative accommodation for tenants or loss of rent up to 20% of the buildings sum insured'
    },
    LandlordBuildingsUpTo: {
        id: 'qnb.sph.IpidPage.insured.LandlordBuildingsUpTo',
        defaultMessage: 'Buildings up to {landlorBuildingsUpToValue}'
    },
    LandlordElectricity: {
        id: 'qnb.sph.IpidPage.insured.LandlordElectricity',
        defaultMessage: 'Unauthorised use of electricity/gas and water up to £1,000'
    },
    LandlordFixtures: {
        id: 'qnb.sph.IpidPage.insured.LandlordFixtures',
        defaultMessage: 'Fixtures and Fittings cover up to £10,000'
    },
    LandlordLegalExpanses: {
        id: 'qnb.sph.IpidPage.insured.LandlordLegalExpanses',
        defaultMessage: 'Legal Expenses cover up to £100,000 for a range of legal proceedings including tenancy eviction'
    },
    LandlordLiability: {
        id: 'qnb.sph.IpidPage.insured.LandlordLiability',
        defaultMessage: 'Property owner\'s liability up to £2,000,000'
    },
    LandlordLockReplacement: {
        id: 'qnb.sph.IpidPage.insured.LandlordLockReplacement',
        defaultMessage: 'Lock replacement up to £1,000'
    },
    LandlordDamageByFire: {
        id: 'qnb.sph.IpidPage.insured.LandlordDamageByFire',
        defaultMessage: 'Loss or damage caused by specific causes such as fire, flood, storm, escape of water or subsidence'
    },
    LandlordRentGuarantee: {
        id: 'qnb.sph.IpidPage.insured.LandlordRentGuarantee',
        defaultMessage: 'Rent guarantee up to {rentGuaranteeCoverLevel} per month while you are trying to evict a tenant'
    },
    LandlordStorageContents: {
        id: 'qnb.sph.IpidPage.insured.LandlordStorageContents',
        defaultMessage: 'Storage of contents up to 20% of the contents sum insured'
    },
    LandlordTraceAndAccess: {
        id: 'qnb.sph.IpidPage.insured.LandlordTraceAndAccess',
        defaultMessage: 'Trace, access and repair up to £5,000'
    },
    // Tailormade insured
    TailormadeAccidentalDamage: {
        id: 'qnb.sph.IpidPage.insured.TailormadeAccidentalDamage',
        defaultMessage: 'Full Accidental Damage cover as standard'
    },
    TailormadeAlternativeAccommodation: {
        id: 'qnb.sph.IpidPage.insured.TailormadeAlternativeAccommodation',
        defaultMessage: 'Up to 3 years alternative accommodation costs'
    },
    TailormadeAwayFromHome: {
        id: 'qnb.sph.IpidPage.insured.TailormadeAwayFromHome',
        defaultMessage: 'Cover for Items taken away from your home as standard'
    },
    TailormadeCreditCard: {
        id: 'qnb.sph.IpidPage.insured.TailormadeCreditCard',
        defaultMessage: 'Worldwide money and credit card cover up to £5,000'
    },
    TailormadeEmergencyAccessCover: {
        id: 'qnb.sph.IpidPage.insured.TailormadeEmergencyAccessCover',
        defaultMessage: 'Emergency access cover'
    },
    TailormadeLeaks: {
        id: 'qnb.sph.IpidPage.insured.TailormadeLeaks',
        defaultMessage: 'Trace and access of a leak'
    },
    TailormadeOwnersLiability: {
        id: 'qnb.sph.IpidPage.insured.TailormadeOwnersLiability',
        defaultMessage: '£10 million owners liability cover'
    },
    TailormadePersonalLiability: {
        id: 'qnb.sph.IpidPage.insured.TailormadePersonalLiability',
        defaultMessage: '£10 million personal liability cover'
    },
    TailormadeValuables: {
        id: 'qnb.sph.IpidPage.insured.TailormadeValuables',
        defaultMessage: 'Valuables covered up to {valuablesLimit}'
    },
    TailormadeWorksOfArt: {
        id: 'qnb.sph.IpidPage.insured.TailormadeWorksOfArt',
        defaultMessage: 'Works of Art covered up to £15,000 as standard'
    },
    TailormadeContentsValuables: {
        id: 'qnb.sph.IpidPage.insured.TailormadeContentsValuables',
        defaultMessage: 'Up to {valuablesLimit} for valuables in your home'
    },
    // Home emergency insured
    SheHelpline: {
        id: 'qnb.sph.IpidPage.insured.SheHelpline',
        defaultMessage: '24 hour emergency helpline open 365 days a year'
    },
    SheHomeEmergencies: {
        id: 'qnb.sph.IpidPage.insured.SheHomeEmergencies',
        defaultMessage: 'Home emergencies relating to:<ul><li>Internal plumbing</li><li>Drainage</li><li>Internal electrical failure</li><li>Internal gas supply pipes</li><li>Water supply pipes</li><li>Roof damage where water is entering the property</li><li>Pest infestation: mice, rats, wasps, hornets and cockroaches</li><li>Broken or damaged windows, doors and locks; or lost, stolen or damaged keys</li></ul>'
    },
    SheHomeAdnHeatingEmergencies: {
        id: 'qnb.sph.IpidPage.insured.SheHomeAdnHeatingEmergencies',
        defaultMessage: 'Home emergencies relating to:<ul><li>Internal plumbing</li><li>Drainage</li><li>Internal electrical failure</li><li>Internal gas supply pipes</li><li>Water supply pipes</li><li>Roof damage where water is entering the property</li><li>Pest infestation: mice, rats, wasps, hornets and cockroaches</li><li>Broken or damaged windows, doors and locks; or lost, stolen or damaged keys</li><li>The complete failure of your boiler or main heating system</li></ul>'
    },
    SheIncidents: {
        id: 'qnb.sph.IpidPage.insured.SheIncidents',
        defaultMessage: 'Up to £2,000 per incident for call outs, labour, parts and materials'
    },
    SheBoilerFailure: {
        id: 'qnb.sph.IpidPage.insured.SheBoilerFailure',
        defaultMessage: 'Cover is extended to include emergencies relating to the complete failure of your boiler or main heating system'
    },
    SheBoilerRepair: {
        id: 'qnb.sph.IpidPage.insured.SheBoilerRepair',
        defaultMessage: 'If your boiler is beyond economical repair we will reimburse you £250 towards a new boiler'
    },
    SheOvernightAccommodation: {
        id: 'qnb.sph.IpidPage.insured.SheOvernightAccommodation',
        defaultMessage: 'Three nights overnight accommodation if your home is uninhabitable following an emergency'
    },
    SheBoilerService: {
        id: 'qnb.sph.IpidPage.insured.SheBoilerService',
        defaultMessage: 'Annual safety and efficiency check on your boiler'
    },
    CompleteHomeAndHeatingCareExtension: {
        id: 'qnb.sph.IpidPage.insured.CompleteHomeAndHeatingCareExtension',
        defaultMessage: 'Cover is extended to include a number of plumbing and electrical maintenance issues'
    },
    CompleteHomeAndHeatingCareBoilerFailure: {
        id: 'qnb.sph.IpidPage.insured.CompleteHomeAndHeatingCareBoilerFailure',
        defaultMessage: 'Partial failure of your boiler or main heating system'
    },
    CompleteHomeAndHeatingCareBoilerCoverIncrease: {
        id: 'qnb.sph.IpidPage.insured.CompleteHomeAndHeatingCareBoilerCoverIncrease',
        defaultMessage: 'Cover increased up to £500 towards a new boiler if under 7 years old'
    },
    SheUnlimitedCalls: {
        id: 'qnb.sph.IpidPage.insured.SheUnlimitedCalls',
        defaultMessage: 'Unlimited call outs each year'
    },
    // Legal insured
    LegalCostClaim: {
        id: 'qnb.sph.IpidPage.insured.LegalCostClaim',
        defaultMessage: 'Up to £100,000 per claim to cover your legal costs'
    },
    LegalCybercrime: {
        id: 'qnb.sph.IpidPage.insured.LegalCybercrime',
        defaultMessage: 'Online safety support services'
    },
    LegalDispute1: {
        id: 'qnb.sph.IpidPage.insured.LegalDispute1',
        defaultMessage: 'Death, personal injury, and medical negligence disputes'
    },
    LegalDispute2: {
        id: 'qnb.sph.IpidPage.insured.LegalDispute2',
        defaultMessage: 'Contract disputes when buying, selling or leasing any personl goods or services'
    },
    LegalDispute3: {
        id: 'qnb.sph.IpidPage.insured.LegalDispute3',
        defaultMessage: 'Contract disputes when buying or selling your property'
    },
    LegalDispute4: {
        id: 'qnb.sph.IpidPage.insured.LegalDispute4',
        defaultMessage: 'Tenancy disputes against landlords'
    },
    LegalDispute5: {
        id: 'qnb.sph.IpidPage.insured.LegalDispute5',
        defaultMessage: 'Property disputes if there has been damage, or there could be damage to your property or following any cases of nuisance or trespass including squatters'
    },
    LegalDispute6: {
        id: 'qnb.sph.IpidPage.insured.LegalDispute6',
        defaultMessage: 'Disputes with your employer over your contract of employment'
    },
    LegalHelpline: {
        id: 'qnb.sph.IpidPage.insured.LegalHelpline',
        defaultMessage: 'Access to a 24-hour freephone helpline for your personal legal matters'
    },
    LegalIdentityFraud: {
        id: 'qnb.sph.IpidPage.insured.LegalIdentityFraud',
        defaultMessage: 'Cover for Personal Identity Fraud'
    },
    LegalProsecution: {
        id: 'qnb.sph.IpidPage.insured.LegalProsecution',
        defaultMessage: 'Defence as an employee if an event arises from your work which leads to your prosecution'
    },
    // NOT INSURED

    // No Ad Not insured
    AccidentalDamage: {
        id: 'qnb.sph.IpidPage.notInsured.AccidentalDamage',
        defaultMessage: 'Accidental damage to your {buildingOrContentAccidentalDamage}'
    },
    // All Not insured
    Excess: {
        id: 'qnb.sph.IpidPage.notInsured.Excess',
        defaultMessage: 'Any excess applicable as shown in your Schedule'
    },
    ExcessSchedule: {
        id: 'qnb.sph.IpidPage.notInsured.ExcessSchedule',
        defaultMessage: 'The excesses shown in your Schedule and in the Endorsements section in your Statement of Insurance'
    },
    SpecificallyExcludedSchedule: {
        id: 'qnb.sph.IpidPage.notInsured.SpecificallyExcludedSchedule',
        defaultMessage: 'Anything specifically excluded in the Endorsements section within your Statement of Insurance'
    },
    DamageByWearAndTear: {
        id: 'qnb.sph.IpidPage.notInsured.DamageByWearAndTear',
        defaultMessage: 'Loss or damage caused by: lack of maintenance of your property, wear and tear, wet or dry rot, or anything else that happens gradually'
    },
    DamageByWearAndTearShort: {
        id: 'qnb.sph.IpidPage.notInsured.DamageByWearAndTearShort',
        defaultMessage: 'Loss or damage caused by wear and tear'
    },
    DamageCausedDeliberately: {
        id: 'qnb.sph.IpidPage.notInsured.DamageCausedDeliberately',
        defaultMessage: 'Loss or damage caused deliberately by you'
    },
    DamageToFences: {
        id: 'qnb.sph.IpidPage.notInsured.DamageToFences',
        defaultMessage: 'Loss or damage to fences, gates and hedges caused by storm or flood'
    },
    // Not away from home cover Not insured
    UnspecifiedPersonalBelongings: {
        id: 'qnb.sph.IpidPage.notInsured.UnspecifiedPersonalBelongings',
        defaultMessage: 'Cover for unspecified personal belongings away from your home'
    },
    // Landlord Not insured
    LandlordLoss1: {
        id: 'qnb.sph.IpidPage.notInsured.LandlordLoss1',
        defaultMessage: 'Storm or flood damage to swimming pool covers, gates, hedges or fences'
    },
    LandlordLoss2: {
        id: 'qnb.sph.IpidPage.notInsured.LandlordLoss2',
        defaultMessage: 'Loss or damage caused deliberately by you, your tenants (unless theft or malicious acts or vandalism) or any person acting on your behalf'
    },
    LandlordTenancyEviction: {
        id: 'qnb.sph.IpidPage.notInsured.LandlordTenancyEviction',
        defaultMessage: 'Tenancy eviction proceedings if no tenancyagreement is in place'
    },
    // Tailormade Not insured
    TailormadeDamageToGates: {
        id: 'qnb.sph.IpidPage.notInsured.TailormadeDamageToGates',
        defaultMessage: 'Damage caused by storm or flood to gates, hedges and fences or materials'
    },
    TailormadeDamageDeliberately: {
        id: 'qnb.sph.IpidPage.notInsured.TailormadeDamageDeliberately',
        defaultMessage: 'Loss or damage caused deliberately by you or any person acting on your behalf'
    },
    TailormadeMaliciousDamage: {
        id: 'qnb.sph.IpidPage.notInsured.TailormadeMaliciousDamage',
        defaultMessage: 'Damage for malicious damage, vandalism, theft or attempted theft by anyone living at the property'
    },
    // Legal Not insured
    LegalBuildingWork: {
        id: 'qnb.sph.IpidPage.notInsured.LegalBuildingWork',
        defaultMessage: 'Any building work where the contract exceeds £20,000'
    },
    LegalClaims1: {
        id: 'qnb.sph.IpidPage.notInsured.LegalClaims1',
        defaultMessage: 'Any claims for tenancy disputes that happen in the first 90 days of cover starting'
    },
    LegalClaims2: {
        id: 'qnb.sph.IpidPage.notInsured.LegalClaims2',
        defaultMessage: 'Any claims for employment disputes that happen in the first 60 days of cover starting'
    },
    LegalIncidents: {
        id: 'qnb.sph.IpidPage.notInsured.LegalIncidents',
        defaultMessage: 'Any incidents that happen before the start of Legal Expenses policy'
    },

    // SHE Not insured
    SheEmergencies: {
        id: 'qnb.sph.IpidPage.notInsured.SheEmergencies',
        defaultMessage: 'An emergency that happens due to something that you were aware of before the start of the policy'
    },
    SheIv2Boilers: {
        id: 'qnb.sph.IpidPage.notInsured.SheIv2Boilers',
        defaultMessage: 'Boilers with an output over 70kw'
    },
    SheNotEmergencies: {
        id: 'qnb.sph.IpidPage.notInsured.SheNotEmergencies',
        defaultMessage: 'An event that is not classed as an emergency i.e. an event that does not require immediate action to prevent damage or further damage and/or to make your home safe, secure and habitable'
    },
    SheProblems1: {
        id: 'qnb.sph.IpidPage.notInsured.SheProblems1',
        defaultMessage: 'Problems relating to a roof, plumbing, drainage, water supply pipes, electrics, doors or windows, if these are shared (e.g. if you live in a flat)'
    },
    SheProblems2: {
        id: 'qnb.sph.IpidPage.notInsured.SheProblems2',
        defaultMessage: 'Problems relating to thatched, glass, plastic, felt, tarpaulin or flat roofs'
    },
    SheBoilerOrHeatingProblems: {
        id: 'qnb.sph.IpidPage.notInsured.SheBoilerOrHeatingProblems',
        defaultMessage: 'Problems relating to boilers or heating'
    },
    SheBoilerServiceNotInsured: {
        id: 'qnb.sph.IpidPage.notInsured.SheBoilerServiceNotInsured',
        defaultMessage: 'Warm air and solar heated systems'
    },
    SheIv2WarmAir: {
        id: 'qnb.sph.IpidPage.notInsured.SheIv2WarmAir',
        defaultMessage: 'Warm air and solar heated systems'
    },
    SheIv2HeatingSystem: {
        id: 'qnb.sph.IpidPage.notInsured.SheIv2HeatingSystem',
        defaultMessage: 'Problems relating to any partial failure of your main heating system or boiler'
    },

    // RESTRICTIONS
    AdditionalConditionsMayApply: {
        id: 'qnb.sph.IpidPage.restrictions.AdditionalConditionsMayApply',
        defaultMessage: 'Additional conditions may apply that require you to take specific actions to protect your property; if you do not follow these requirements your claim may be declined in full or in part. These will be detailed in the Endorsements section of your Statement of Insurance'
    },
    RestrictionsWhenHomeUnoccupied: {
        id: 'qnb.sph.IpidPage.restrictions.RestrictionsWhenHomeUnoccupied',
        defaultMessage: 'Unless agreed by us in advance, cover for theft, escape of water or oil, malicious damage or vandalism is excluded if your home is unoccupied for more than 60 days in a row'
    },
    NotPayMoreThanSumInsured: {
        id: 'qnb.sph.IpidPage.restrictions.NotPayMoreThanSumInsured',
        defaultMessage: 'We will not pay more than the amount shown as the sum insured in your Schedule'
    },
    BuildingWorkOrRenovations: {
        id: 'qnb.sph.IpidPage.restrictions.BuildingWorkOrRenovations',
        defaultMessage: 'Unless agreed by us in advance, no cover is provided when your home is undergoing building work or renovations, other than routine repairs and maintenance which do not require scaffolding'
    },
    // Landlord restrictions
    LandlordVandalismRestrictions: {
        id: 'qnb.sph.IpidPage.restrictions.LandlordVandalismRestrictions',
        defaultMessage: 'Any amount recoverable from a tenant following theft or malicious acts or vandalism by them'
    },
    LandlordPropertyUnoccupiedRestrictions: {
        id: 'qnb.sph.IpidPage.restrictions.LandlordPropertyUnoccupiedRestrictions',
        defaultMessage: 'No cover for theft, escape of water, trace and access or malicious acts or vandalism if the property is unoccupied for more than 60 days'
    },
    LandlordTrespassRestrictions: {
        id: 'qnb.sph.IpidPage.restrictions.LandlordTrespassRestrictions',
        defaultMessage: 'Any nuisance or trespass by a non-tenant within 45 days of cover starting'
    },
    LandlordContractDisputes: {
        id: 'qnb.sph.IpidPage.restrictions.LandlordContractDisputes',
        defaultMessage: 'Any contract disputes less than £250 plus VAT'
    },
    LandlordRentGuaranteeSumInsuredFiveThousand: {
        id: 'qnb.sph.IpidPage.restrictions.LandlordRentGuaranteeSumInsuredFiveThousand',
        defaultMessage: 'Rent payments under Rent Guarantee if you are not able to make a valid claim under tenancy eviction cover'
    },
    LandlordRentGuaranteeSumInsuredTwoThousandFiveHundred: {
        id: 'qnb.sph.IpidPage.restrictions.LandlordRentGuaranteeSumInsuredTwoThousandFiveHundred',
        defaultMessage: 'Rent payments under Rent Guarantee if you are not able to make a valid claim under tenancy eviction cover'
    },
    LandlordRentGuaranteeSumInsuredTwoThousandFiveHundredArrears: {
        id: 'qnb.sph.IpidPage.restrictions.LandlordRentGuaranteeSumInsuredTwoThousandFiveHundredArrears',
        defaultMessage: 'Rent payments under Rent Guarantee if you are not able to make a valid claim under tenancy eviction cover'
    },
    // Tailormade restrictions
    TailormadeHomeUnoccupied: {
        id: 'qnb.sph.IpidPage.restrictions.TailormadeHomeUnoccupied',
        defaultMessage: 'Unless agreed by us, cover for theft, escape of water or malicious damage or vandalism is excluded if your home is unoccupied for more than 60 days in a row'
    },
    TailormadeHaveOtherInsurance: {
        id: 'qnb.sph.IpidPage.restrictions.TailormadeHaveOtherInsurance',
        defaultMessage: 'If you have any other insurance covering anything insured by this policy, we will pay only our share of any claim'
    },
    TailormadePaySumInsured: {
        id: 'qnb.sph.IpidPage.restrictions.TailormadePaySumInsured',
        defaultMessage: 'We will not pay more than the amount shown as the sum insured on your Schedule'
    },
    // Legal Restrictions
    LegalDisputedRestriction: {
        id: 'qnb.sph.IpidPage.restrictions.LegalDisputedRestriction',
        defaultMessage: 'The likely value of the <b>legal claim</b> must be greater than the costs of pursuing the <b>legal claim</b>'
    },
    LegalClaimRestriction: {
        id: 'qnb.sph.IpidPage.restrictions.LegalClaimRestriction',
        defaultMessage: 'We must consider there to be a 51% or above chance of succeeding with your claim'
    },
    LegalTenancyDispute: {
        id: 'qnb.sph.IpidPage.restrictions.LegalTenancyDispute',
        defaultMessage: 'Any claims for tenancy or employment disputes that happen in the first 90 days of cover starting'
    },
    // She restrictions

    SheClaim: {
        id: 'qnb.sph.IpidPage.restrictions.SheClaim',
        defaultMessage: 'You cannot claim within the first 14 days of your policy'
    },
    SheHomeUnoccupied: {
        id: 'qnb.sph.IpidPage.restrictions.SheHomeUnoccupied',
        defaultMessage: 'Cover is excluded if your home is unoccupied for more than 60 days in a row'
    },
    SheLossDamage: {
        id: 'qnb.sph.IpidPage.restrictions.SheLossDamage',
        defaultMessage: 'Cover is excluded for any loss or damage caused by a lack of maintenance including if your boiler or main heating system is not maintained to the manufacturer\'s specifications (i.e. your boiler needs to be regularly serviced)'
    },
    SheAnnualBoiler: {
        id: 'qnb.sph.IpidPage.restrictions.SheAnnualBoiler',
        defaultMessage: 'The annual boiler service will only cover your main boiler and not any secondary boilers in the property'
    },
    // COVERED

    CommonCoveredCountries1: {
        id: 'qnb.sph.IpidPage.covered.CommonCoveredCountries1',
        defaultMessage: 'United Kingdom'
    },
    CommonCoveredCountries2: {
        id: 'qnb.sph.IpidPage.covered.CommonCoveredCountries2',
        defaultMessage: 'Isle of Man'
    },
    CommonCoveredCountries3: {
        id: 'qnb.sph.IpidPage.covered.CommonCoveredCountries3',
        defaultMessage: 'Channel Islands'
    },

    // bike covered
    BicycleCover: {
        id: 'qnb.sph.IpidPage.covered.BicycleCover',
        defaultMessage: 'Bicycles covered under this policy are covered for up to 60 consecutive days in Europe'
    },
    // legal covered
    SPHLegalExpensesCovered: {
        id: 'qnb.sph.IpidPage.covered.SPHLegalExpensesCovered',
        defaultMessage: 'Gibraltar'
    },
    // unspecitem covered
    SPHPersonalBelongingsUnspecifiedItems: {
        id: 'qnb.sph.IpidPage.covered.SPHPersonalBelongingsUnspecifiedItems',
        defaultMessage: '{unspecifiedAndSpecified} Personal Belongings (excluding bicycles) are covered anywhere in the world'
    },
    // Tailormade covered
    TailormadeCoveredCountries: {
        id: 'qnb.sph.IpidPage.covered.TailormadeCoveredCountries',
        defaultMessage: 'Contents and valuables are covered anywhere in the world'
    },

    // OBLIGATIONS

    SphObigations1: {
        id: 'qnb.sph.IpidPage.obligations.SphObigations1',
        defaultMessage: 'It is your duty to provide us with correct information and answer our questions with reasonable care, honestly, truthfully, and completely'
    },
    SphObigations2: {
        id: 'qnb.sph.IpidPage.obligations.SphObigations2',
        defaultMessage: 'You must contact us as soon as possible after anything happens which may lead to a claim'
    },
    SphObigations3: {
        id: 'qnb.sph.IpidPage.obligations.SphObigations3',
        defaultMessage: 'You must take care to prevent or reduce any loss, destruction, damage or injury, and maintain anything covered by this insurance'
    },
    SphObigations4: {
        id: 'qnb.sph.IpidPage.obligations.SphObigations4',
        defaultMessage: 'You must tell us within 30 days of any changes in your circumstances that may affect your insurance or the cover provided, such as renovation work at the property, change in tenancy or if the property becomes unoccupied'
    },
    SphObigations5: {
        id: 'qnb.sph.IpidPage.obligations.SphObigations5',
        defaultMessage: 'You must comply with all conditions set out in the Policy Book and Statement of Insurance'
    },

    // She obligations
    SheObligations1: {
        id: 'qnb.sph.IpidPage.obligations.SheObligations1',
        defaultMessage: 'It is your duty to provide us with correct information and answer our questions with reasonable care, and honestly, truthfully, and completely. You must tell us as quickly as possible if you change your home address or your boiler'
    },
    SheObligations2: {
        id: 'qnb.sph.IpidPage.obligations.SheObligations2',
        defaultMessage: 'If you have a home emergency that is covered by this policy, call the Saga Home Emergency helpline or log your claim online as soon as possible. Both services are available 24 hours a day, 365 days a year'
    },
    SheObligations3: {
        id: 'qnb.sph.IpidPage.obligations.SheObligations3',
        defaultMessage: 'You must check that you do not have any other insurance policies that may cover the same events and costs as these benefits'
    },
    // Legal obligations
    LegalExpansesObligations1: {
        id: 'qnb.sph.IpidPage.obligations.LegalExpansesObligations1',
        defaultMessage: 'It is your duty to provide us with correct information and answer our questions with reasonable care, and honestly, truthfully, and completely'
    },
    LegalExpansesObligations2: {
        id: 'qnb.sph.IpidPage.obligations.LegalExpansesObligations2',
        defaultMessage: 'You must contact us as soon as possible after anything happens which may lead to a claim'
    },
    LegalExpansesObligations3: {
        id: 'qnb.sph.IpidPage.obligations.LegalExpansesObligations3',
        defaultMessage: 'You must make every effort to provide all documents and/or documents and/or any information requested by us or your appointed representative in a timely manner'
    },
    LegalExpansesObligations4: {
        id: 'qnb.sph.IpidPage.obligations.LegalExpansesObligations4',
        defaultMessage: 'You must not admit any responsibility, deny any claim, negotiate or make an offer or promise to pay or do anything which may harm your claim without our written permission'
    }
});
